/**
 * Read by screen readers, not shown: the full sentence behind a chart mark.
 * Sizes are strings on purpose: in `sx`, a bare `1` means 100%.
 */
export const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
} as const;
